/* eslint-disable react/no-unescaped-entities */
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../../lib/siteData";

export const Footer = () => {
  return (
    <footer
      className="relative bg-[#080D0A] border-t border-[#223026] pt-24 pb-10"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20">
          <div className="md:col-span-6">
            <h3 className="font-display font-black uppercase tracking-tighter text-5xl md:text-7xl text-white leading-[0.9]">
              Let's build <br /> something solid<span className="text-lime-400">.</span>
            </h3>
            <a
              href="#estimate"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 mt-8 bg-lime-400 text-black font-semibold px-7 py-4 text-sm uppercase tracking-wider hover:bg-white transition-colors"
            >
              Get a Free Estimate <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <span className="text-xs uppercase tracking-[0.2em] text-neutral-500">Contact</span>
            <a
              href={CONTACT.phoneHref}
              className="flex items-center gap-2 text-white text-lg mt-4 hover:text-lime-400 transition-colors"
              data-testid="footer-phone"
            >
              <Phone size={16} /> {CONTACT.phone}
            </a>
            <p className="flex items-center gap-2 text-neutral-400 mt-3">
              <MapPin size={16} /> {CONTACT.location}
            </p>
          </div>

          <div className="md:col-span-2">
            <span className="text-xs uppercase tracking-[0.2em] text-neutral-500">Menu</span>
            <div className="flex flex-col gap-2 mt-4">
              {["Work", "Services", "About", "Estimate"].map((l) => (
                <a
                  key={l}
                  href={`#${l.toLowerCase()}`}
                  className="text-neutral-400 hover:text-white transition-colors w-max"
                >
                  {l}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#223026] flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-display font-bold uppercase tracking-tight text-white text-sm">
            Eklund Land Management<span className="text-lime-400">.</span>
          </p>
          <p className="text-neutral-500 text-sm">
            {CONTACT.tagline}
          </p>
          <p className="text-neutral-600 text-xs">
            © {new Date().getFullYear()} — {CONTACT.owner}
          </p>
        </div>
      </div>
    </footer>
  );
};
